import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  editButton: {
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  buttonDelete: {
    "&.disabled": {
      pointerEvents: "none !important",
      background: "#ccc",
      cursor: "unset",
      "&:hover, &:focus, &:active": {
        background: "#ccc",
      },
    },
    marginRight: 40,
  },
  ProjectDetailLayout: {
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
  },
  attachements: {
    marginTop: 10,
    marginBottom: 20,
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  infoHeight: {
    minHeight: "295px",
    '& div[class="bodyContainer*"]': {
      minHeight: "335px",
    },
  },
  customHeader: {
    display: "flex",
    marginLeft: 18,
    alignItems: "center",
  },
  calendar: {
    display: "flex",
    padding: "0 18px",
    alignItems: "center",
    borderLeft: `1px solid ${theme.color.gray2}`,
    borderRight: `1px solid ${theme.color.gray2}`,
    color: theme.color.gray5,
    fontSize: 14,
    marginRight: 18,
  },
  calendarIcon: {
    width: 18,
    marginRight: 8,
  },
  statusBadge: {
    borderRight: `1px solid ${theme.color.gray2}`,
    paddingRight: "18px",
    marginRight: "18px",
  },
  switchButton: {
    "& span": {
      fontSize: 14,
    },
  },
  projectInformationHeader: {
    "&:first-child": {
      marginRight: 18,
    },
    width: "68%",
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        flex: 1,
      },
      "& .left": {
        paddingRight: "10px",
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: "0 20px",
      },
      "& .label": {
        color: theme.color.black,
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: theme.color.blue,
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
      "& .disable": {
        color: theme.color.gray5,
      },
    },
  },
  modalDesactive: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "508px !important",
    },
    "& .MuiDialogActions-spacing": {
      justifyContent: "space-between !important",
    },
  },
  modalContainer: {
    padding: "0 50px",
    textAlign: "center",
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: "300px",
      background: theme.color.white,
    },
  },
  ctaDone: {
    color: `${theme.color.gray3} !important`,
    pointerEvents: "none",
    "&:hover": {
      color: `${theme.color.gray3} !important`,
    },
  },
  noPadding: {
    padding: 0,
  },
  DisabledText: {
    color: `${theme.color.gray3} !important`,
  },
  SwitchControl: {
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
  },
  ProjectsPage__AddCta: {
    marginRight: "10px !important",
  },
  ProjectsPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
}));
